import * as React from 'react'
import { Link } from 'react-router-dom'

import theme from 'theme'
import Button from 'components/common/Button'
import Text from 'components/common/Text'

type CreationInvitationHeaderProps = {
  heading: React.ReactNode
  subheading: React.ReactNode
  buttonText?: string
  link?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}

const CreationInvitationHeader: React.FC<CreationInvitationHeaderProps> = ({
  heading,
  subheading,
  buttonText,
  link,
  onClick,
  ...rest
}) => {
  return (
    <div
      css={{
        display: 'grid',
        gridAutoFlow: 'column',
        alignItems: 'center',
        marginBottom: theme.space[5],
        gap: theme.space[4],
        justifyContent: 'start'
      }}
      {...rest}
    >
      {link && buttonText && (
        <Link to={link}>
          <Button data-test-new-attack>{buttonText}</Button>
        </Link>
      )}
      {onClick && buttonText && (
        <Button data-test-new-attack onClick={onClick}>
          {buttonText}
        </Button>
      )}
      <div>
        <Text as="h3" color="dark">
          {heading}
        </Text>
        <Text as="h4" color="normal" weight="normal">
          {subheading}
        </Text>
      </div>
    </div>
  )
}

export default CreationInvitationHeader
